import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../Config";

const ExcelUpload = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  console.log("Selected file:", file);

  const handleUpload = async () => {
    if (!file) {
      toast.error("Please select an Excel file first!");
      return;
    }

    const formData = new FormData();
    formData.append("excelFile", file);

    try {
      setLoading(true);
      const res = await axios.post(
        `${baseUrl}/upload-excel`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success(res.data.message);
    } catch (err) {
      toast.error(err.response?.data?.error || "Upload failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h3 className="text-lg font-semibold mb-2">Upload Candidate Excel</h3>
      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={handleFileChange}
        className="border p-2 rounded"
      />
      <button
        onClick={handleUpload}
        disabled={loading}
        className="ml-3 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        {loading ? "Uploading..." : "Upload"}
      </button>
    </div>
  );
};

export default ExcelUpload;
